import React, { useState } from 'react';
import api from '../services/api';

export default function ConnectWACloudWizard() {
  const [step, setStep] = useState(1);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const [callbackUrl, setCallbackUrl] = useState('https://tudominio.com/webhooks/wa-cloud');
  const [verifyToken, setVerifyToken] = useState('PUX_VERIFY_TOKEN');

  const runConnectMeta = async () => {
    try {
      setBusy(true); setMsg('');
      const r = await api.waCloud.connectMeta();
      setMsg(r?.message || 'OK');
      setStep(2);
    } catch (e) {
      setMsg(`Error: ${e.message}`);
    } finally {
      setBusy(false);
    }
  };

  const runSetWebhook = async () => {
    try {
      setBusy(true); setMsg('');
      const r = await api.waCloud.setWebhook({ callbackUrl, verifyToken });
      setMsg(`Webhook configurado (mock): ${r.callbackUrl}`);
      setStep(5);
    } catch (e) {
      setMsg(`Error: ${e.message}`);
    } finally {
      setBusy(false);
    }
  };

  const runTestWebhook = async () => {
    try {
      setBusy(true); setMsg('');
      const r = await api.waCloud.testWebhook();
      setMsg(r?.ok ? 'Evento de prueba enviado (mock)' : 'No se pudo probar');
    } catch (e) {
      setMsg(`Error: ${e.message}`);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ padding: 16 }}>
      <h2>WhatsApp Cloud API (Wizard)</h2>

      <ol style={{ opacity: 0.8 }}>
        <li style={{ fontWeight: step >= 1 ? '600' : '400' }}>Conectar con Meta (simulado)</li>
        <li style={{ fontWeight: step >= 2 ? '600' : '400' }}>Seleccionar Business → WABA → App</li>
        <li style={{ fontWeight: step >= 3 ? '600' : '400' }}>Elegir/crear número y token</li>
        <li style={{ fontWeight: step >= 4 ? '600' : '400' }}>Configurar webhook y probar</li>
        <li style={{ fontWeight: step >= 5 ? '600' : '400' }}>Sincronizar plantillas / Enviar prueba</li>
      </ol>

      <div style={{ marginTop: 16, border: '1px dashed #ccc', borderRadius: 8, padding: 16 }}>
        {step === 1 && (
          <div>
            <p>Paso 1 — Iniciar proceso con Meta (mock, sin OAuth real todavía).</p>
            <button onClick={runConnectMeta} disabled={busy}>
              {busy ? 'Conectando…' : 'Conectar con Meta (simulado)'}
            </button>
          </div>
        )}

        {step === 2 && (
          <div>
            <p>Paso 2 — Selección de Business, WABA y App (placeholder).</p>
            <button onClick={() => setStep(3)}>Continuar</button>
          </div>
        )}

        {step === 3 && (
          <div>
            <p>Paso 3 — Elegir/crear número y token (placeholder).</p>
            <button onClick={() => setStep(4)}>Continuar</button>
          </div>
        )}

        {step === 4 && (
          <div>
            <p>Paso 4 — Configurar Webhook y probar (mock).</p>
            <div style={{ display: 'grid', gap: 8, maxWidth: 520 }}>
              <label>
                Callback URL
                <input
                  style={{ width: '100%' }}
                  value={callbackUrl}
                  onChange={(e) => setCallbackUrl(e.target.value)}
                />
              </label>
              <label>
                Verify Token
                <input
                  style={{ width: '100%' }}
                  value={verifyToken}
                  onChange={(e) => setVerifyToken(e.target.value)}
                />
              </label>
              <div style={{ display: 'flex', gap: 8 }}>
                <button onClick={runSetWebhook} disabled={busy}>
                  {busy ? 'Guardando…' : 'Guardar webhook (mock)'}
                </button>
                <button onClick={runTestWebhook} disabled={busy}>
                  {busy ? 'Probando…' : 'Probar webhook (mock)'}
                </button>
              </div>
            </div>
          </div>
        )}

        {step === 5 && (
          <div>
            <p>Paso 5 — Sincronización de plantillas / Enviar prueba (placeholder).</p>
            <div style={{ display: 'flex', gap: 8 }}>
              <a href="/whatsapp-cloud/numbers">Ir a Números & Webhooks</a>
              <a href="/whatsapp-cloud/templates">Ir a Plantillas</a>
            </div>
          </div>
        )}
      </div>

      {msg && <div style={{ marginTop: 12, padding: 8, border: '1px solid #eee' }}>{msg}</div>}
    </div>
  );
}